<template>
<div class="field">
  <label v-if="label">{{ label }}</label>
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/field.vue